import { deepFreeze } from '@utils/objectUtil';

export default deepFreeze({
  HEAD_OFFICE: { code: 1, royalty: 0 },
  DIRECT_MANAGEMENT: { code: 2, royalty: 0 },
  FRANCHISE1: { code: 3, royalty: 15000 },
  FRANCHISE2: { code: 4, royalty: 20000 },
  FRANCHISE_teaching: { code: 5, royalty: 10000 },
});
